import { Request, AxiosRequestAdapterFactory, Repeatimiter, createRequestCache } from '@fanghub/tool-request'
import type { AdapterFactory } from '@fanghub/tool-request'
import { permissionHandler } from './handlers/permission'
import { loadingHandler } from './handlers/loading'
import { responseHandler } from './handlers/response'
// 自定义缓存装饰器
const CacheWithTTL = createRequestCache({ cacheTTL: 10 * 1000 }) // 30秒缓存
const adapterFactory: AdapterFactory = new AxiosRequestAdapterFactory({
    // 配置
    config: {
        baseURL: import.meta.env.VITE_API_BASEPATH,
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 100000
    },
    // 拦截器
    interceptors: [loadingHandler, permissionHandler, responseHandler],
    // 装饰器
    decorators: [Repeatimiter, CacheWithTTL]
}) as AdapterFactory
export const request = new Request(adapterFactory)
